export function createMissingDateImplError(provider: string) {
  return Error(
    `DatetimePicker: No provider found for ${provider}. You must import one of the following ` +
    `modules at your application root: DiyMatNativeDateModule, DiyMatMomentDateModule, or provide a ` +
    `custom implementation.`,
  );
}
